module.exports = "<div \n  class=\"loading-spinner-container\" \n  [class.full-screen]=\"fullScreen\"\n  [class.with-overlay]=\"overlay\"\n>\n  <div class=\"loading-spinner-wrapper\" [ngClass]=\"'size-' + size\">\n    <div class=\"spinner\"></div>\n    <p *ngIf=\"message\" class=\"loading-message\">{{ message }}</p>\n  </div>\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// /Users/ldt/Desktop/afropay_admin/afropay-admin-frontend/src/app/common/loading-spinner/loading-spinner.component.html
// module id = ../../../../../src/app/common/loading-spinner/loading-spinner.component.html
// module chunks = main